import React from 'react';
import UnplannedMaintenancePage from '../../pages/public/UnplannedMaintenancePage';

interface IUnplannedMaintenanceBoundaryProps {
	children: React.ReactNode;
}

interface IUnplannedMaintenanceBoundaryState {
	showMaintenance: boolean;
	errorCode?: string;
	errorMessage?: string;
}

export class UnplannedMaintenanceBoundary extends React.Component<
	IUnplannedMaintenanceBoundaryProps,
	IUnplannedMaintenanceBoundaryState
> {
	constructor(props: IUnplannedMaintenanceBoundaryProps) {
		super(props);
		this.state = { showMaintenance: false };
		this.handleMaintenanceEvent = this.handleMaintenanceEvent.bind(this);
	}

	// async componentDidMount() {
	//   try {
	//     const response = { status: 200, statusText: "OK" };
	//     if (response.status === 200) {
	//       this.setState({ showMaintenance: true, errorCode: String(response.status), errorMessage: response.statusText });
	//     }
	//   } catch (e: any) {
	//     //fallback
	//   }
	//   window.addEventListener('unplanned-maintenance', this.handleMaintenanceEvent as EventListener);
	// }

	componentDidMount() {
		window.addEventListener(
			'unplanned-maintenance',
			this.handleMaintenanceEvent as EventListener
		);
	}

	componentWillUnmount() {
		window.removeEventListener(
			'unplanned-maintenance',
			this.handleMaintenanceEvent as EventListener
		);
	}

	handleMaintenanceEvent(event: CustomEvent) {
		this.setState({
			showMaintenance: true,
			errorCode: event.detail?.errorCode,
			errorMessage: event.detail?.errorMessage,
		});
	}

	render() {
		if (this.state.showMaintenance) {
			return (
				<UnplannedMaintenancePage
					errorCode={this.state.errorCode}
					errorMessage={this.state.errorMessage}
				/>
			);
		}
		return this.props.children;
	}
}
